<form class="opportunityForm" #opportunityForm="ngForm">
  @if (opportunity(); as opportunity) {
    <div class="toolbar">
      <span>
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" (click)="backToOpportunityMaster()">
          <span>
            <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
            <label class="buttonLabel">All Opportunities</label>
          </span>
        </button>
      </span>
      <span class="spacer"></span>
      <span>
        <button matButton="text" class="toolbarButton" [disabled]="isBusy() || !opportunityForm.valid"
          (click)="saveOpportunity()">
          <span>
            <mat-icon class="size-16">save</mat-icon>
            <label class="buttonLabel">Save</label>
          </span>
        </button>
        <button matButton="text" class="toolbarButton" [disabled]="isBusy()" [matMenuTriggerFor]="viewMenu">
          <span>
            <label class="buttonLabel">View</label>
            <mat-icon class="size-16">arrow_drop_down</mat-icon>
          </span>
        </button>
        <mat-menu #viewMenu="matMenu" [overlapTrigger]="false">
          @if (associatedQuotes() && associatedQuotes().length > 0) {
            <button class="menuButton" mat-menu-item
              (click)="viewQuotes()">
              <mat-icon class="size-12">attach_file</mat-icon>
              <label>Associated Quotes</label>
            </button>
          }
        </mat-menu>
      </span>
    </div>
  }
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  @if (isBusy()) {
    <div class="busyIndicator">
      <div class="busyContents">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <label class="busyLabel">Please Wait...</label>
      </div>
    </div>
  }
  @if (opportunity(); as opportunity) {
    <div class="opportunityDetail">
      <div class="thirdColumn">
        <div class="infoPanel">
          <div class="panelHeader">
            <label>Opportunity Information</label>
          </div>
          <div class="panelBody">
            <table class="layoutTable">
              <tr>
                <td class="rightAligned labelColumn"><label>Opportunity ID:</label></td>
                <td class="dataColumn"><label>{{ opportunity.id.entityId }};{{ opportunity.id.entityRevision }}</label>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Project Name:</label></td>
              <td class="dataColumn"><label>{{ opportunity.projectName }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Customer:</label></td>
              <td class="dataColumn"><label>{{ opportunity.customerDescription }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Rep Office:</label></td>
              <td class="dataColumn"><label>{{ opportunity.repOfficeDescription }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Associated Quote ID:</label></td>
              <td class="dataColumn"><label>{{ opportunity.associatedQuoteId }}</label></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Reporting Dimensions</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>Marketing Segment:</label></td>
              <td class="dataColumn"><label>{{ marketSegmentDescription() }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Project Type:</label></td>
              <td class="dataColumn"><label>{{ projectTypeDescription() }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Spec Type:</label></td>
              <td class="dataColumn"><label>{{ specTypeDescription() }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Application Type:</label></td>
              <td class="dataColumn"><label>{{ applicationTypeDescription() }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Channel:</label></td>
              <td class="dataColumn"><label>{{ salesChannelDescription() }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Lead Time:</label></td>
              <td class="dataColumn"><label>{{ leadTimeDescription() }}</label></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Quote Contacts</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr align="center">
              <td>
                <span class="repSelection" (click)="showOutsideSalesRep()">
                  Outside Sales Rep
                </span>
              </td>
            </tr>
            <tr align="center">
              <td>
                <span class="repSelection" (click)="showSalesRep()">
                  Sales Rep
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="thirdColumn">
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Opportunity Status</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>Status:</label></td>
              <td class="dataColumn">
                <div [ngClass]="{'selectionError': statusSelection.invalid}">
                  <select id="statusSelection" name="statusSelection" class="inputField" required
                    [(ngModel)]="opportunity.statusCode" #statusSelection="ngModel">
                    <option value="">Please Select</option>
                    @for (status of statuses(); track status) {
                      <option [value]="status.code">{{ status.description }}</option>
                    }
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Current Phase:</label></td>
              <td class="dataColumn">
                <div [ngClass]="{'selectionError': phaseSelection.invalid}">
                  <select id="phaseSelection" name="phaseSelection" class="inputField" required
                    [(ngModel)]="opportunity.currentPhaseCode" #phaseSelection="ngModel"
                    (change)="refreshAwardProbabilityPercent(opportunity.currentPhaseCode)">
                    <option value="">Please Select</option>
                    @for (phase of phases(); track phase) {
                      <option [value]="phase.code">{{ phase.description }}</option>
                    }
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Percent to Close:</label></td>
              <td class="dataColumn"><label>{{ opportunity.awardProbabilityPercent }} %</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Last Status Change:</label></td>
              <td class="dataColumn"><label>{{
                opportunity.lastStatusChangeTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC'
              }}</label></td>
            </tr>
            <tr>
              <td class="dataColumn">
                <input name="includeInForecastInput" id="includeInForecastInput" class="checkboxInput" type="checkbox"
                  [(ngModel)]="opportunity.includeInForecast"/>
                <label for="includeInForecastInput">Include in Forecast?</label>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Important Dates</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>Expected Order Placed:</label></td>
              <td class="dataColumn">
                <input [matDatepicker]="expectedBookDatePicker" name="expectedBookDateInput"
                  [value]="formatDisplayDate(opportunity.expectedBookDate)"
                  (dateChange)="setExpectedBookDate($event.value)"/>
                <mat-datepicker-toggle [for]="expectedBookDatePicker"></mat-datepicker-toggle>
                <mat-datepicker [startAt]="dateStartValue(opportunity.expectedBookDate)" id="expectedBookDatePicker"
                name="expectedBookDatePicker" #expectedBookDatePicker></mat-datepicker>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Expected 1st Shipment:</label></td>
              <td class="dataColumn">
                <input [matDatepicker]="expectedFirstShipmentDatePicker" name="expectedFirstShipmentDateInput"
                  [value]="formatDisplayDate(opportunity.expectedFirstShipmentDate)"
                  (dateChange)="setExpectedFirstShipmentDate($event.value)"/>
                <mat-datepicker-toggle [for]="expectedFirstShipmentDatePicker"></mat-datepicker-toggle>
                <mat-datepicker [startAt]="dateStartValue(opportunity.expectedFirstShipmentDate)"
                  id="expectedFirstShipmentDatePicker" name="expectedFirstShipmentDatePicker"
                #expectedFirstShipmentDatePicker></mat-datepicker>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Quote Price Basis Dt:</label></td>
              <td class="dataColumn"><label>{{ associatedQuote().priceBasisDate | date: 'MM/dd/yyyy':'UTC' }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Quote Last Update Dt:</label></td>
              <td class="dataColumn"><label>{{
                associatedQuote().updateTimestamp | date: 'MM/dd/yyyy h:mm:ss a':'UTC'
              }}</label></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="thirdColumn">
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Opportunity Totals</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>Total List:</label></td>
              <td class="dataColumn"><label>{{ associatedQuote().totalList | currency:'USD' }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Total Quote Amt:</label></td>
              <td class="dataColumn"><label>{{ associatedQuote().totalQuoteAmount | currency:'USD' }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Multiplier:</label></td>
              <td class="dataColumn"><label>{{ associatedQuote().multiplier | number:'1.5-5' }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Unit Qty:</label></td>
              <td class="dataColumn"><label>{{ associatedQuote().unitQuantity }}</label></td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label for="projectedPriceInput">Projected Price:</label></td>
              <td class="dataColumn">
                <input id="projectedPriceInput" name="projectedPriceInput" class="inputField standardTextBox"
                  maxlength="30" pattern="^\$?\d+(\.(\d{1,2}))?$"
                  [ngClass]="{'inputError': projectedPriceInput.invalid}" [(ngModel)]="opportunity.projectedPrice"
                  #projectedPriceInput="ngModel"/>
              </td>
            </tr>
            <div [hidden]="projectedPriceInput.valid" class="alert alert-danger">
              <div [hidden]="!projectedPriceInput.hasError('pattern')">
                Projected Price must be numeric
              </div>
            </div>
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Loss Data</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td class="rightAligned labelColumn"><label>Main Competitor:</label></td>
              <td class="dataColumn">
                <select name="competitorInput" class="inputField" [(ngModel)]="opportunity.mainCompetitor">
                  <option value="">Please Select</option>
                  @for (competitor of competitors(); track competitor) {
                    <option [value]="competitor.id">{{ competitor.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Loss Reason 1:</label></td>
              <td class="dataColumn">
                <select name="wonLoss1Input" class="inputField" [(ngModel)]="opportunity.wonLossReasonCode1">
                  <option value="">Please Select</option>
                  @for (wonLossReason of wonLossReasons(); track wonLossReason) {
                    <option [value]="wonLossReason.code">
                      {{ wonLossReason.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
            <tr>
              <td class="rightAligned labelColumn"><label>Loss Reason 2:</label></td>
              <td class="dataColumn">
                <select name="wonLoss2Input" class="inputField" [(ngModel)]="opportunity.wonLossReasonCode2">
                  <option value="">Please Select</option>
                  @for (wonLossReason of wonLossReasons(); track wonLossReason) {
                    <option [value]="wonLossReason.code">
                      {{ wonLossReason.description }}
                    </option>
                  }
                </select>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="infoPanel">
        <div class="panelHeader">
          <label>Notes</label>
        </div>
        <div class="panelBody">
          <table class="layoutTable">
            <tr>
              <td colspan="2">
                <textarea name="externalNotesInput" rows="2" class="noresize fullWidth"
                  [(ngModel)]="opportunity.externalNotes" placeholder="External Notes"
                #externalNotesInput></textarea>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <textarea name="internalNotesInput" rows="2" class="noresize fullWidth"
                  [(ngModel)]="opportunity.internalNotes" placeholder="Internal Notes"
                #internalNotesInput></textarea>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
}
</form>
